import { getItemWebStorage } from "../features/webStorageSaver";
import { store } from "../stateManagement/store";

export async function fetchObjectGeometry(urlType: string, objectType: string, objectId: string) {
    const token = store.getState().auth.tokens.app
    const currentApiUrl = getItemWebStorage("currentApiUrl")
    let errorFlag = false
    let successFlag = false
    let response: any
    let cleanedText: any
    try {
        response = await fetch(`${currentApiUrl}/${urlType}/${objectType}(${objectId})/GeometryText`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            },
        });
        if (response.ok) {
            successFlag = true
        }
        else {
            errorFlag = true
        }
    }
    catch (error) {
        errorFlag = true
    }
    if (response) {
        const text: any = await response?.text();
        cleanedText = text.replace(/\0/g, '');
    }
    return { data: cleanedText, isError: errorFlag, isSuccess: successFlag }
}

export async function fetchCoordsToPosition(roadId: any, pathId: any, latitude: any, longitude: any) {
    const currentApiUrl = getItemWebStorage("currentApiUrl")
    const token = store.getState().auth.tokens.app
    let response: any
    try {
        response = await fetch(`${currentApiUrl}/address/coordsToPosition?PathId=${pathId}&RoadId=${roadId}&Latitude=${latitude}&Longitude=${longitude}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            },
        });
    } catch (error) {
        console.error(error)
    }
    if (response) {
        const data: any = await response.json()
        return data
    }
}